import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';

const BrandGrid = () => {
  const navigate = useNavigate();

  const brands = [
    'Harrods',
    'Selfridges',
    'Fortnum & Mason',
    'Harvey Nichols',
    'Liberty London',
    'Burberry',
    'Chanel',
    'Dior'
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
      {brands.map((brand) => (
        <button
          key={brand}
          onClick={() => navigate(`/jobs?brand=${encodeURIComponent(brand)}`)}
          className="bg-card border border-border rounded-2xl p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 flex flex-col items-center justify-center text-center group w-full"
        >
          <div className="bg-primary/5 p-4 rounded-full mb-4 group-hover:bg-primary/10 group-hover:scale-110 transition-all duration-300">
            <ShoppingBag className="w-8 h-8 text-primary" />
          </div>
          <h3 className="text-brand-name text-foreground group-hover:text-primary transition-colors duration-300">
            {brand}
          </h3>
        </button>
      ))}
    </div>
  );
};

export default BrandGrid;